import {Helmet} from '@dr.pogodin/react-helmet';
import {isFeatureEnabled} from 'feature-flags';

import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {
  SettingsStackItemProps,
  SettingsStackItems,
  SettingsTemplate,
  SettingsTemplateHeader,
} from '@dms/settings/shared';
import {formatDocumentTitle, usePermissions} from '@dms/shared';

import {buildArray} from 'shared/web';

export function Advertising() {
  const [hasConfigureBackgroundRemovalPermission] = usePermissions({
    permissionKeys: ['configureBackgroundRemoval'],
  });

  const header: SettingsTemplateHeader = {title: i18n.t('page.salesSettings.labels.advertising')};

  const items = buildArray<SettingsStackItemProps>([
    {
      cyId: testIds.settings.advertising('platforms-link'),
      title: i18n.t('page.salesSettings.labels.platforms'),
      url: settingsRoutes.advertisingPlatforms,
    },
    {
      cyId: testIds.settings.advertising('promoPhotos-link'),
      title: i18n.t('page.salesSettings.labels.promotionalPhotos'),
      url: settingsRoutes.advertisingPromoPhotos,
    },
    {
      cyId: testIds.settings.advertising('watermark-link'),
      title: i18n.t('page.salesSettings.labels.watermark'),
      url: isFeatureEnabled(featureFlags.SETTINGS_WATERMARKS)
        ? settingsRoutes.advertisingWatermarking
        : settingsRoutes.advertisingWatermarkingOld,
    },
    {
      cyId: testIds.settings.advertising('qrCodeDefinition-link'),
      title: i18n.t('page.salesSettings.labels.qrCodeDefinitionTitle'),
      url: settingsRoutes.advertisingQrCodeDefinition,
    },
  ])
    .when(hasConfigureBackgroundRemovalPermission, {
      cyId: testIds.settings.advertising('backgroundRemoval-link'),
      title: i18n.t('page.salesSettings.labels.backgroundRemoval'),
      url: settingsRoutes.backgroundRemoval,
    })
    .whenFeatureEnabled(featureFlags.SALES_SALE_PROGRAMS, {
      cyId: testIds.settings.advertising('sale-preset-link'),
      title: i18n.t('page.salesSettings.labels.salePreset'),
      url: settingsRoutes.salePreset,
    });

  return (
    <>
      <Helmet
        title={formatDocumentTitle(
          i18n.t('page.salesSettings.labels.advertising'),
          i18n.t('page.settings.labels.title')
        )}
      />
      <SettingsTemplate header={header} data-testid="settings-advertising">
        <SettingsStackItems items={items} />
      </SettingsTemplate>
    </>
  );
}
